import React, { useEffect, useState } from 'react';
export const PriceDisplay = () => {
  const [price, setPrice] = useState('$6.36 USD');
  useEffect(() => {
    const lang = navigator.language || 'en-US';
    if (lang.includes('es-MX') || lang === 'es-MX') {
      setPrice('$109 MXN');
    } else if (lang.includes('es-ES') || lang.includes('eu') || lang.includes('ca') || lang.includes('gl') || lang === 'es') {
      setPrice('€5.90 EUR');
    } else if (lang.includes('en-GB')) {
      setPrice('£5.10 GBP');
    } else {
      setPrice('$6.36 USD');
    }
  }, []);
  return <span className="font-bold" data-id="element-106">{price}</span>;
};